<template>
  <b-container fluid class='header'>
    <b-jumbotron fluid class='py-4'>
      <h1 class='mt-4'>Dashboard</h1>
      <p>Reports and analytics</p>
    </b-jumbotron>

    <h4>HubSpot</h4>
    <b-card>
      Integration details
    </b-card>

    <h4>Zapier</h4>
    <b-card>
      Integration details
    </b-card>

    <h4>API</h4>
    <b-card>
      Integration details
    </b-card>

    <h4>HTML</h4>
    <b-card>
      Integration details
    </b-card>

    <b-container class="mt-2 main">
      <b-card-group deck class='mx-a'>
        <b-card class='mb-2 bg-primary-4 stat' title="Recipients">
          <h3>0</h3>
        </b-card>
      </b-card-group>
    </b-container>
  </b-container>
</template>

<script>

import { db } from '@/main.js'

export default {
  metaInfo: {title: 'Integrations'},
  props: ['profile'],
  data() {
    return {

    }
  },
  methods: {

  },
}
</script>

<style scoped>

.jumbotron {
  min-height: 200px;
}

</style>
